import { contactInfo } from "../data/contact";

export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://www.tradesquareltd.com"
).replace(/\/$/, "");

export const IS_PRODUCTION_SITE =
  SITE_URL === "https://www.tradesquareltd.com";

export const SITE_NAME = "Trade Square";
export const SITE_TITLE_SUFFIX = " — Trade Square";
export const DEFAULT_DESCRIPTION =
  "Trade Square Co., Ltd. — AWS consulting, data platforms, and custom software delivery based in Bangkok, Thailand.";
export const DEFAULT_OG_IMAGE = "/og-default.png";

export const absoluteUrl = (pathOrUrl) => {
  if (!pathOrUrl) return undefined;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const path = pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
  return `${SITE_URL}${path}`;
};

export const organizationJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: contactInfo.companyName,
  url: SITE_URL,
  logo: absoluteUrl("/logo512.png"),
  email: contactInfo.email,
  telephone: contactInfo.phone,
  address: {
    "@type": "PostalAddress",
    streetAddress: contactInfo.address,
    addressLocality: "Bangkok",
    addressCountry: "TH",
  },
  sameAs: [contactInfo.facebook, contactInfo.linkedin].filter(Boolean),
});
